import { NodoArbolMenu } from "./nodo-arbol-menu";

export class ArbolMenu{
    height:number;
    childs:NodoArbolMenu[];
    root: NodoArbolMenu;

    constructor(root:NodoArbolMenu){
        this.root = root;
    }

    buildTree(jsonArbolMenu){
        if (this.root != null){
            
            this.childs = this.root.buildTree(jsonArbolMenu)
            return  this;
        }
        return this; 
    }

    search(nodeId:string):NodoArbolMenu{
        let nodo;
        if (this.root != null){
            nodo = this.root.search(nodeId)
        }
        return nodo; 
    }

}